import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
const {
  mfePublicPath,
  baseUrl,
  custAuthUrl,
} = process.env;

const DEAULT_HEADERS = {
  'Content-Type': 'application/json',
  'x-source-country': 'SG',
  'x-source-id': 'ROA',
  id: 'ROA',
  'Access-Control-Allow-Origin': true,
};
export const callAPI = async (url, httpHeaders, methodType, reqBody, enableToken) => {

  if (enableToken) {
    httpHeaders['x-acc-id'] = sessionStorage.getItem('ACD');;
  }

  const response = await fetch(url, {
    method: methodType,
    headers: {
      ...httpHeaders,
      'x-source-date-time': moment()
        .format('YYYY-MM-DD-HH:mm:ss.SSS'),
      'x-correlation-id': uuidv4(),
    },
    cache: 'no-cache',
    body: reqBody,
  })
  
  const data = await response;
  if(data.headers.get('x-acc-id')){
    const accId = data.headers.get('x-acc-id');
    sessionStorage.setItem('ACD',accId);
  }

  
  
  return data.json();
};


export const expirationCheck = async (pid) => {
  const body = JSON.stringify({
    uniqueId: pid,
  });
  const resp = await callAPI(`${baseUrl}/woo/setup/expiration/check`, DEAULT_HEADERS, 'POST', body, false);
  return resp;
};

export const resendOtp = async (transactionId, authorizationId, authorizationTypeCode) => {
  const body = JSON.stringify({
    transactionId: transactionId,
    authorizationId: authorizationId,
    authorizationTypeCode: authorizationTypeCode,
  });
  const resp = await callAPI(`${custAuthUrl}/v3/mfa/otp`, DEAULT_HEADERS, 'POST', body, false);
  return resp;
};


export const eligibilityCheck = async (cid, custId, dob) => {
  const body = JSON.stringify({
    caseId: cid,
    // pid: uid,
    nric: custId,
    dateBirth: dob,
  });
  const resp = await callAPI(`${baseUrl}/woo/setup/eligibility/check`, DEAULT_HEADERS, 'POST', body, true);
  return resp;
};

export const otpValidate = async (data) => {
  const body = JSON.stringify(data);
  const resp = await callAPI(`${baseUrl}/woo/setup/otp/validate`, DEAULT_HEADERS, 'POST', body, true);
  return resp;
};

export const getInbRandomNumber = async (cid) => {
  const body = JSON.stringify({
    caseId: cid,
  });
  const resp = await callAPI(`${baseUrl}/woo/setup/inb/getrandomnumber`, DEAULT_HEADERS, 'POST', body);
  return resp;
};

export const getGwpRandomNumber = async (cid) => {
  const body = JSON.stringify({
    caseId: cid,
  });
  const resp = await callAPI(`${baseUrl}/woo/setup/gwp/getrandomnumber`, DEAULT_HEADERS, 'POST', body, true);
  return resp;
};

export const setupINB = async (cid, loginId, pStr, cStr) => {
  const body = JSON.stringify({
    caseId: cid,
    loginid: loginId,
    cstring: cStr,
    pstring: pStr,
  });
  const resp = await callAPI(`${baseUrl}/woo/setup/inb/access`, DEAULT_HEADERS, 'POST', body, true);
  return resp;
};

export const setupOnline = async (cid, loginId, pStr, cStr) => {
  const body = JSON.stringify({
    caseId: cid,
    loginId: loginId,
    cstring: cStr,
    pstring: pStr,
  });
  const resp = await callAPI(`${baseUrl}/woo/setup/ospl/access`, DEAULT_HEADERS, 'POST', body);
  return resp;
};


export const contentAPI = async () => {
  const data = await callAPI(
    `${mfePublicPath}/public/json/contentManagement.json`,
    {
      ...DEAULT_HEADERS,
    },
    'GET',
  );
  return data;
};
